export const getDotsStatus = (selectedIndex = 0, shift = 0, length = 0, dotsToShow = 5) => {
  const visibleArea = new Array(dotsToShow).fill(1);
  const shiftCoeff = Math.floor((selectedIndex - shift) / dotsToShow);
  let hiddenHead = shift;
  if (selectedIndex <= shift && shift > 0) {
    hiddenHead = Math.max(shift - shiftCoeff - 1, 0);
  }
  if (selectedIndex >= shift + dotsToShow - 1 && shift + dotsToShow < length) {
    hiddenHead = Math.min(Math.max(shift + shiftCoeff + 1, 0), length);
  }
  const hiddenTail = length - (hiddenHead + dotsToShow);
  for (let i = 0; i < visibleArea.length; i++) {
    if (i === 0 && hiddenHead !== 0 || i === dotsToShow - 1 && hiddenTail !== 0) visibleArea[i] = 0;
    if (selectedIndex - hiddenHead === i) visibleArea[i] = 2;
  }
  return {
    visibleArea,
    shiftIndex: hiddenHead
  };
};